import { useState } from 'react';
import { fmtCompactAmount, CHART_PRIMARY } from '../utils';
import { ChartEmptyState } from './ChartEmptyState';

const BAR_AREA_HEIGHT = 180;

export function ProductRevenueChart({ data = [], locale }) {
  const [hover, setHover] = useState(null);
  if (!data.length) return <ChartEmptyState />;

  const max = Math.max(...data.map((d) => d.amountEur), 1);

  return (
    <div>
      <div className="relative" style={{ height: BAR_AREA_HEIGHT }}>
        <div className="absolute inset-0 flex flex-col justify-between pointer-events-none">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="border-t border-slate-100 w-full" />
          ))}
        </div>
        <div className="absolute inset-0 flex items-end gap-3 px-1">
          {data.map((d) => {
            const heightPct = Math.max((d.amountEur / max) * 100, 2);
            const isHovered = hover === d.productName;
            const isDimmed = hover != null && !isHovered;
            return (
              <div
                key={d.productName}
                className="flex-1 flex flex-col items-center justify-end h-full min-w-0"
                onMouseEnter={() => setHover(d.productName)}
                onMouseLeave={() => setHover(null)}
              >
                <div
                  className={`text-[10.5px] font-semibold text-slate-700 mb-1 tabular-nums transition-opacity ${
                    isHovered ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  {fmtCompactAmount(d.amountEur, locale)}
                </div>
                <div
                  className="w-full max-w-[32px] rounded-t-[4px] transition-opacity"
                  style={{
                    height: `${heightPct}%`,
                    backgroundColor: CHART_PRIMARY,
                    opacity: isDimmed ? 0.35 : 0.85,
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex gap-3 px-1 mt-2">
        {data.map((d) => (
          <div
            key={d.productName}
            className="flex-1 min-w-0 text-center text-[10px] text-slate-500 truncate"
            title={d.productName}
          >
            {d.productName}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductRevenueChart;
